export default "__VITE_ASSET__5c967f87__"